import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { getThreads } from '../actions/data';
import Home from '../components/Home';

const mapStateToProps = ({ data }) => {
  return {
    threads: data.threads,
    error: data.getThreadsError
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getThreads() {
      dispatch(getThreads());
    },
    openThread(id) {
      dispatch(push('/home/threads/' + id));
    },
    showThreadList() {
      dispatch(push('/home/threads'));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
